import { useState, useEffect, React } from "react";
import { useDispatch, useSelector } from "react-redux";
import api from "../../utils/api";
// import { StarIcon } from "@material-ui/icons/Star";
import { useParams } from "react-router-dom";
import {
  Avatar,
  Box,
  Button,
  Card,
  CardContent,
  CardHeader,
  CardMedia,
  Grid,
  IconButton,
  Stack,
  Typography,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";

import "react-responsive-carousel/lib/styles/carousel.min.css"; // requires a loader
import { Carousel } from "react-responsive-carousel";
import CallIcon from "@mui/icons-material/Call";
import HomeIcon from "@mui/icons-material/Home";
import CategoryIcon from "@mui/icons-material/Category";
import StarIcon from "@mui/icons-material/Star";
const ScholarshipDetails = () => {
  const [scholarship, setScholarship] = useState({});
  const userstate = useSelector((state) => state.loginUserReducer);
  const { currentUser } = userstate;
  const params = useParams();

  useEffect(() => {
    api
      .get(`/scholarships/by-id/${params?.scholarshipId}`)
      .then((res) => {
        console.log("scholarship>", res.data);
        setScholarship(res.data);
      })
      .catch((err) => console.log(err));
  }, []);
  /********* */
  const [uploader, setUploader] = useState("");
  useEffect(() => {
    scholarship?.userId &&
      api
        .get(`/user/getUserdataById/` + scholarship?.userId)
        .then((res) => {
          // console.log("user", res?.data);
          setUploader(res?.data);
        })
        .catch((err) => console.log("err", err));
  }, [scholarship]);
  /********* */

  const navigate = useNavigate();

  const deletescholarship = (i) => {
    api
      .delete(`/scholarships/${i?._id}`)
      .then((res) => {
        if (res.data) {
          let notifBody = {
            userId: currentUser?.id,
            text: `Admin delete your scholarships for violating terms and conditions.`,
            forAll: false,
            receiverId: i?.userId,
          };
          api
            .post("/notifications", notifBody)
            .then((re) => console.log("notif", re.data));
          window.location.reload();
        }
      })
      .catch((err) => console.log);
  };
  return (
    <Box className="container">
      <Card sx={{ width: "100%", marginTop: "20px" }}>
        <CardHeader
          avatar={
            <Stack direction="column">
              {uploader?.profile ? (
                <Avatar src={uploader?.profile} />
              ) : (
                <Avatar sx={{ bgcolor: "colorThree.main" }} aria-label="recipe">
                  {uploader?.name?.at(0)?.toUpperCase()}
                </Avatar>
              )}
            </Stack>
          }
          // action={
          //   <IconButton aria-label="settings">
          //     <MoreVertIcon />
          //   </IconButton>
          // }
          title={uploader?.name?.toUpperCase()}
          subheader={new Date(scholarship?.createdAt).toDateString()}
        />
        <CardContent>
          <Grid container gap={4} sx={{ marginTop: "20px" }}>
            {/* <Grid item xs={2}>
              <img
                src={scholarship?.companyLogoImage}
                style={{ width: "130px", height: "130px" }}
              />
            </Grid> */}
            <Grid item xs={8}>
              <Box>
                <Typography
                  variant="h6"
                  sx={{ fontWeight: "600", color: "fontPrimaryColor.main" }}
                >
                  {scholarship?.title}
                </Typography>
              </Box>
            </Grid>
          </Grid>

          <Grid container gap={3} sx={{ marginTop: "20px" }}>
            <Grid
              item
              xs={12}
              sm={5}
              sx={{ marginTop: "30px", paddingRight: "10px" }}
            >
              <Box>
                <Typography
                  variant="h6"
                  sx={{ fontWeight: "600", marginBottom: "10px" }}
                >
                  Description
                </Typography>
                <Typography
                  variant="body2"
                  sx={{ marginTop: "10px", color: "fontPrimaryColor.main" }}
                >
                  {scholarship?.description}
                </Typography>
              </Box>
              <Box sx={{ marginTop: "20px" }}>
                <Typography
                  variant="h6"
                  sx={{ flex: "0.5", fontWeight: "600" }}
                >
                  Eligibility Criteria
                </Typography>
                <Typography sx={{ flex: "0.5" }}>
                  {scholarship?.eligibilityCriteria
                    ? scholarship?.eligibilityCriteria
                    : "N/A"}
                </Typography>
              </Box>
            </Grid>
            <Grid
              item
              xs={12}
              sm={6}
              sx={{
                marginTop: "20px",
                borderLeft: "1px dashed lightgray",
                padding: "30px 0",
                display: "flex",
                flexDirection: "column",
                gap: "20px",
                paddingLeft: "20px",
              }}
            >
              <Box sx={{ display: "flex" }}>
                <Typography sx={{ flex: "0.5", fontWeight: "600" }}>
                  Scholarship For
                </Typography>
                <Typography sx={{ flex: "0.5" }}>
                  {scholarship?.scholarshipFor}
                </Typography>
              </Box>
              <Box sx={{ display: "flex" }}>
                <Typography sx={{ flex: "0.5", fontWeight: "600" }}>
                  Country
                </Typography>
                <Typography sx={{ flex: "0.5" }}>
                  {scholarship?.country}
                </Typography>
              </Box>
              <Box sx={{ display: "flex" }}>
                <Typography sx={{ flex: "0.5", fontWeight: "600" }}>
                  Stipend
                </Typography>
                <Typography sx={{ flex: "0.5" }}>
                  {scholarship?.amount}
                </Typography>
              </Box>
              <Box sx={{ display: "flex" }}>
                <Typography sx={{ flex: "0.5", fontWeight: "600" }}>
                  Deadline
                </Typography>
                <Typography sx={{ flex: "0.5" }}>
                  {scholarship?.deadline}
                </Typography>
              </Box>
              <Box sx={{ display: "flex" }}>
                <Typography sx={{ flex: "0.5", fontWeight: "600" }}>
                  Duration
                </Typography>
                <Typography sx={{ flex: "0.5" }}>
                  {scholarship?.duration}
                </Typography>
              </Box>
              <Box sx={{ display: "flex" }}>
                <Typography sx={{ flex: "0.5", fontWeight: "600" }}>
                  Scholarship Type
                </Typography>
                <Typography sx={{ flex: "0.5" }}>
                  {scholarship?.scholarshipType
                    ? scholarship?.scholarshipType
                    : "N/A"}
                </Typography>
              </Box>
            </Grid>
            <Grid item xs={12}></Grid>
            <a
              className="asc__submit__form__button"
              href={scholarship?.url}
              target="_blank"
              style={{ marginLeft: "auto" }}
            >
              Click to apply
            </a>
          </Grid>

          {/* <a href={scholarship?.generalData?.scholarshipLocationLink} target="_blank">
        See Live Location
      </a> */}

          <Box sx={{ marginTop: "30px" }}>
            {currentUser?.isAdmin ? (
              <button
                className=" asc__submit__form__button"
                onClick={() => deletescholarship(scholarship)}
              >
                Delete scholarship
              </button>
            ) : (
              <></>
            )}
          </Box>
        </CardContent>
      </Card>
    </Box>
  );
};

export default ScholarshipDetails;
